import { render, staticRenderFns } from "./CorrectorsPage.vue?vue&type=template&id=7b2cfd49"
import script from "./CorrectorsPage.vue?vue&type=script&lang=js"
export * from "./CorrectorsPage.vue?vue&type=script&lang=js"
import style0 from "./CorrectorsPage.vue?vue&type=style&index=0&id=7b2cfd49&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports